var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw-ProductCardFunction"},_vm._l((_vm.functions),function(item){return _c('div',{key:item.productCardDisplayName,class:[
      'sw-ProductCardFunction_Item',
      { 'sw-ProductCardFunction_Item-inactive': item.color === _vm.DISABLED_COLOR }
    ],style:({'--square-color': item.color})},[_c('span',[_vm._v(_vm._s(_vm.getDisplayName(item.productCardDisplayName)))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }